// Registry: tipo de nó -> componente de config dedicado. Tipos sem entrada usam SchemaConfig.
import { markRaw } from 'vue';
import MediaConfig from '../MediaConfig.vue';
import ConditionConfig from '../ConditionConfig.vue';
import SwitchConfig from '../SwitchConfig.vue';
import MoveToStageConfig from '../MoveToStageConfig.vue';
import HttpRequestConfig from '../HttpRequestConfig.vue';
import SendWAInteractiveConfig from '../SendWAInteractiveConfig.vue';
import SendWATemplateConfig from '../SendWATemplateConfig.vue';
import StartTriggerConfig from '../StartTriggerConfig.vue';
import KnowledgeBaseConfig from '../KnowledgeBaseConfig.vue';
import SchemaConfig from '../SchemaConfig.vue';

const DEDICATED = {
  knowledgeBase: KnowledgeBaseConfig,
  sendImage: MediaConfig,
  sendVideo: MediaConfig,
  sendAudio: MediaConfig,
  sendFile: MediaConfig,
  condition: ConditionConfig,
  switch: SwitchConfig,
  moveToStage: MoveToStageConfig,
  httpRequest: HttpRequestConfig,
  sendWAInteractive: SendWAInteractiveConfig,
  sendWATemplate: SendWATemplateConfig,
  start: StartTriggerConfig,
};

export const configComponent = type => markRaw(DEDICATED[type] || SchemaConfig);
